export default __webpack_public_path__ + "static/media/AnimalLiberation.02542de9.pdf";